// extracted by mini-css-extract-plugin
export default {"widget_container":"styles_widget_container__Uoc+P","admin":"styles_admin__7PmBf","nonAdmin":"styles_nonAdmin__kmror"};